import { render, staticRenderFns } from "./SDGs.vue?vue&type=template&id=466e4384"
import script from "./SDGs.vue?vue&type=script&lang=js"
export * from "./SDGs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports